import { ShieldCheck, FileCheck2, Gavel, BadgeCheck } from "lucide-react";

const industries = [
  "Healthcare & Health IT",
  "Financial Services",
  "Manufacturing & Industrial",
  "B2B SaaS",
  "Legal & Compliance",
  "PE-backed Operators",
];

const signals = [
  { icon: ShieldCheck, label: "Practitioner-led", sub: "10+ years AppSec & AI security" },
  { icon: FileCheck2, label: "Audit-ready evidence", sub: "Customer, auditor, insurer, board" },
  { icon: Gavel, label: "Regulated-market fluent", sub: "HIPAA · SOC 2 · HITRUST · CMMC" },
  { icon: BadgeCheck, label: "Fixed scope", sub: "Written proposal in 48 hours" },
];

export default function ArqTrustStrip() {
  return (
    <section className="bg-arq-bg border-y border-arq-border/60 py-10 md:py-12 px-6">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-8">
          <div className="font-mono-tech text-[10.5px] tracking-[0.18em] uppercase text-arq-tertiary">
            Built for leadership teams deploying AI into
          </div>
          <div className="mt-3 flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
            {industries.map((i, idx) => (
              <span key={i} className="flex items-center gap-6">
                <span className="text-arq-muted text-[13.5px] md:text-[14px] tracking-[0.02em]">
                  {i}
                </span>
                {idx < industries.length - 1 && (
                  <span aria-hidden className="hidden md:inline text-arq-tertiary/50">·</span>
                )}
              </span>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 pt-6 border-t border-arq-border/60">
          {signals.map(({ icon: Icon, label, sub }) => (
            <div key={label} className="flex items-start gap-3">
              <Icon className="w-4 h-4 mt-0.5 text-arq-blue flex-shrink-0" aria-hidden />
              <div>
                <div className="text-arq-text text-[13.5px] font-semibold leading-tight">
                  {label}
                </div>
                <div className="text-arq-tertiary text-[12px] font-mono mt-1 leading-snug">
                  {sub}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
